import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons/faCircleExclamation';
import { faPencil } from '@fortawesome/free-solid-svg-icons/faPencil';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import { ideaEditUrl } from 'buyside/util/urlHelper';

import styles from '../ideaStatusBarStyles.scss';

const IdeaStatusDraft: React.FC<{ ideaId: string }> = ({ ideaId }) => {
  return (
    <div className={styles.ideaStatusDraft}>
      <div>
        <FontAwesomeIcon icon={faCircleExclamation} className={styles.faIcon} />
        <strong>Preview Mode</strong> &mdash; You are currently previewing a draft of your idea.
      </div>
      <Button
        url={ideaEditUrl(ideaId)}
        type={BUTTON_TYPES.LINK}
        text="BACK TO EDITING"
        faIcon={faPencil}
      />
    </div>
  );
};

export default IdeaStatusDraft;
